/**
 * Dose alarm dialog.
 *
 * The React equivalent of the modal `capsuleAlarm.showModal` built by hand in
 * alarm.js — same three actions (taken / snooze / dismiss), same urgency, but
 * without injecting a `<style>` block into the document on every firing.
 */

import { Icon } from '../../components/common';
import { SNOOZE_MINUTES } from '../../hooks/useMedicineAlarm';
import { formatSecondsAs12h } from '../../domain/dates';

export function MedicineAlarmModal({ alarm, onDismiss, onSnooze, onTaken }) {
  if (!alarm) return null;

  const { med, seconds } = alarm;

  return (
    <div
      className="fixed inset-0 z-[500] flex items-center justify-center bg-black/85 p-4 backdrop-blur-md"
      role="alertdialog"
      aria-modal="true"
      aria-label="تنبيه موعد الدواء"
    >
      <div className="w-full max-w-sm rounded-3xl border-2 border-red-500/50 bg-gradient-to-br from-slate-900 to-indigo-950 p-9 text-center shadow-2xl">
        <div className="mx-auto mb-5 flex h-20 w-20 animate-heartbeat items-center justify-center rounded-full border-2 border-red-500/40 bg-red-500/15">
          <Icon name="bell-ring" size={40} className="text-red-400" />
        </div>

        <h2 className="mb-1 text-xl font-bold text-white">موعد الدواء</h2>
        <p className="mb-1 text-2xl font-bold text-cyan-300">{med?.name}</p>

        {med?.dosage && <p className="mb-1 text-sm text-slate-300">{med.dosage}</p>}
        <p className="mb-6 font-mono text-xs text-slate-500" dir="ltr">
          {formatSecondsAs12h(seconds)}
        </p>

        <div className="space-y-2">
          <button
            type="button"
            onClick={onTaken}
            className="w-full rounded-xl bg-emerald-600 py-3 text-sm font-bold text-white transition-colors hover:bg-emerald-500"
          >
            <Icon name="check" size={16} className="ml-1 inline" />
            تم أخذ الجرعة
          </button>

          <button
            type="button"
            onClick={onSnooze}
            className="w-full rounded-xl bg-amber-600/80 py-3 text-sm font-bold text-white transition-colors hover:bg-amber-500"
          >
            <Icon name="alarm-clock" size={16} className="ml-1 inline" />
            تأجيل {SNOOZE_MINUTES} دقائق
          </button>

          <button
            type="button"
            onClick={onDismiss}
            className="w-full rounded-xl bg-white/5 py-2.5 text-sm font-bold text-slate-300 transition-colors hover:bg-white/10"
          >
            إغلاق
          </button>
        </div>
      </div>
    </div>
  );
}

export default MedicineAlarmModal;
